import {
  Chip,
  FormControl,
  FormGroup,
  FormLabel,
  InputLabel,
  TextField,
  Tooltip,
} from "@mui/material";
import React, { useRef, useState } from "react";
import { renderAlert } from "../../../../../CommonComponents/Alert/Alert";
import PropTypes from "prop-types";

const ListStructure = ({
  listValue,
  setListValue,
  handleInputChange,
  index,
  value,
  propListRefs,
  handleKeyDownOnPropList,
  disable
}) => {
  const listItemRef = useRef(null);
  const [newInputValue, setNewInputValue] = useState("");
  const [isFocused, setIsFocused] = useState(false);

  const handleDeleteList = (event, listToDelete) => {
    const updatedList = value.filter((item) => item !== listToDelete);
    setListValue(updatedList);
    handleInputChange(index, event, "propList", updatedList);
  };
  
  const enterValue = (key, dataType, e) => {
    if (key.toLowerCase() == "enter" && newInputValue) {
      if (dataType.toLowerCase() === "list") {
        if (newInputValue.trim() === "") {
          renderAlert("List item can't be empty", "error");
          return;
        }
        if (value?.includes(newInputValue.trim())) {
          renderAlert(`Duplicate List Value: ${newInputValue}`, "error");
          return;
        }
        if (!value?.includes(newInputValue.trim())) {
          let val;
          if (!value) val = [newInputValue.trim()];
          else val = [...value, newInputValue.trim()];
          setListValue(val);
          handleInputChange(index, e, "propList", val);
        }
        setNewInputValue("");
      } else if (dataType.toLowerCase() === "status") {
        if (newInputValue.trim() === "") {
          renderAlert("List item can't be empty", "error");
          return;
        }
        if (!statuscolumnSubTypeArray.includes(newInputValue.trim())) {
          const val = [...statuscolumnSubTypeArray, newInputValue.trim()];
          setStatuscolumnSubTypeArray(val);
        }
        setNewInputValue("");
      }
    }else if(key.toLowerCase() == "tab"){
      handleKeyDownOnPropList(e, index)
    }
  };

  return (
    <div>
      <InputLabel className="input-label custom-transform">List Items:</InputLabel>
      <FormGroup
        // className="form-group"
        className={`form-group ${isFocused ? "focused" : ""}`} // Dynamic class
        style={{ marginLeft: "0px" }}
        inputRef={listItemRef}
      >
        <FormControl
          className="input-box"
          title="Type a list option & hit enter to add it to the list"
        >
          <input
            ref={propListRefs}
            placeholder="Type a list value and hit <enter>"
            name="propList"
            value={newInputValue}
            onChange={(e) => setNewInputValue(e.target.value)}
            onKeyDown={(e) => enterValue(e.key, "list", e)}
            className="input-field"
            onFocus={() => setIsFocused(true)}  // Set focus state
            onBlur={() => setIsFocused(false)}   // Remove focus state
            disabled = {disable}
          />

        </FormControl>
        <div className="chip-container">
          {value?.length > 0 &&
            value?.map((data, index) => (
              <Tooltip
                key={index}
                title={data}
                followCursor
                placement="top"
                arrow
              >
                <Chip
                  label={data}
                  className="dropdown-chip-style"
                  onDelete={(e) => handleDeleteList(e, data)}
                  disabled = {disable}
                />
              </Tooltip>
            ))}
        </div>
      </FormGroup>
    </div>
  );
};

ListStructure.propTypes = {
  propListRefs: PropTypes.shape({
    current: PropTypes.arrayOf(PropTypes.instanceOf(Element)),
  }),
  handleKeyDownOnPropList: PropTypes.func.isRequired,
};

export default ListStructure;
